export const MessageType = {
  Reservation: 'reservation',
  ReservationStatusChanged: 'reservation_status_changed',
  Message: 'message',
  RefreshMessage: 'refresh_message',
  LoginRepeat: 'login_repeat',
  WebsocketIdentity: 'websocket_identity',
  UserDeleted: 'user_deleted',
  RefreshShopLoginStatus: 'refresh_shop_login_status',
  RefreshTable: 'refresh_table',
  RefreshTableCategory: 'refresh_table_category',
  RefreshTableCart: 'refresh_table_cart',
  RefreshTableCartV2: 'refresh_table_cart_v2',
  OrderCartScopeChanged: 'order_cart_scope_changed',
  RefreshSingleTable: 'refresh_single_table',
  AutoPreCheckout: 'auto_pre_checkout',
  VersionUpdate: 'version_update',
  PreCheckoutReminder: 'pre_checkout_reminder',
  PackageCountdownReminder: 'package_countdown_reminder',
  VersionNotice: 'version_notice',
  RefreshProduct: 'refresh_product',
  CreditExchangeNotification: 'credit_exchange_notification',
  SensitiveApproval: 'sensitive_approval',
  LocalPrintTaskCreated: 'local_print_task_created',
} as const
